import { HeavyFailures, WarningIndicatorType } from '@algoan/dashboard/model';

export const didEventOccur = (
  heavyFailures: HeavyFailures | undefined,
  event: Exclude<
    WarningIndicatorType,
    'internationalTransfers' | 'bankTransactionsToBeJustified' | 'internalTransfersWithoutRelatedTransactions'
  >,
): boolean => {
  return heavyFailures ? heavyFailures[event].transactions.length > 0 : false;
};
